import { HttpHeaders } from "@angular/common/http";
import { Component, OnInit, AfterViewInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Utilities } from "src/app/models/utilities";
import { AppCoreService } from "src/app/services/app-core.service";
import { FileHandlerService } from "src/app/services/file-handler.service";
import Swal from "sweetalert2";
import { saveAs } from 'file-saver-es';
import { CustomerService } from "src/app/services/customer.service";
import { lastValueFrom } from "rxjs";
import { VendorService } from "src/app/services/vendor.service";
import { ChargesService } from "src/app/services/system-config/charges/charges.service";
import { RateBandsService } from "src/app/services/ratebands.service";
import { Title } from "@angular/platform-browser";
import { JobService } from "src/app/services/job.service";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'app-data-import',
    templateUrl: './data-import.component.html',
    styleUrls: ['./data-import.component.scss']
})

export class DataImportComponent implements OnInit, AfterViewInit {
    awbForm: FormGroup;
    odaForm: FormGroup;
    vendorAWBForm: FormGroup;
    chargesForm: FormGroup;
    selectedFile: any;
    awbTypeList: any[] = [{ id: 'awb', name: 'AWB' }, { id: 'forwardingdetails', name: 'Forwarding Details' }, { id: 'poddetails', name: 'POD Details' }];
    odaTypeList: any[] = [{ name: 'Customer' }, { name: 'Vendor' }, { name: 'Tariff' }]
    progress = 0;
    isFormSubmitted = false;
    userData: any;
    currentDate: any;
    chargesFileID: any;
    chargeTypeList = [];
    surchargeTypeList = [{ name: 'Fuel Surcharge' }, { name: 'Other' }];
    chargeCategoriesList = [];
    chargeBandList: []
    showCategory = false;
    isCategoryMand = false;
    showDownloadBtn = false;
    showBands = false;
    showCustomer = false;
    showVendor = false;

    permConfig = {
        isViewAllowed: false,
        isAddAllowed: false,
        isEditAllowed: false,
        isDeleteAllowed: false
    };
    CustomerType = false;
    private gridApi!: GridApi;
    private gridColumnApi!: ColumnApi;
    public context: any;
    defaultColDef = {
        filter: true,
        sortable: true,
        resizable: false,
        flex: 1,
        minWidth: 120,
    };
    activeId = 1;
    // recordStatusObj = { totalRecord: 0, validRecord: 0, invalidRecord: 0 };
    jobListInterval: any;

    gridOptions: GridOptions = {
        pagination: true,
        paginationPageSize: 20,
        domLayout: 'autoHeight',
    }

    customerList: any;
    vendorList = [];
    serviceList = [];
    chargeType: string;
    filePathObj = { awb: 'data-import/AWB-Import.xlsx', oda: 'data-import/ODA_Pincode-Import.xlsx', pincodes: 'data-import/Pincodes.xlsx' };
    useEnterKey = false;
    jobAdded = false;
    isRedirectFromPincode: boolean = false;
    constructor(
        private _fb: FormBuilder,
        private route: ActivatedRoute,
        private appCoreService: AppCoreService,
        private ngxLoaderService: NgxUiLoaderService,
        private fileHandlerService: FileHandlerService,
        private jobService: JobService,
        private utilities: Utilities,
        private customerService: CustomerService,
        private vendorService: VendorService,
        private chargeService: ChargesService,
        private chargeBandsService: RateBandsService,
        private titleService: Title

    ) {
        titleService.setTitle('Data Import');
        this.context = { componentParent: this }
    }

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    }

    ngOnInit(): void {
        // this.productId = this.route.snapshot.params['id'];
        this.isRedirectFromPincode = history.state.redirectFrom;
        this.activeId = this.isRedirectFromPincode? 5: 1;
        this.awbForm = this._fb.group({
            ddlType: ['awb', Validators.required]

        });
        this.odaForm = this._fb.group({
            ddlType: [this.odaTypeList[2].name, Validators.required],
            ddlCustomer: [null, Validators.required],
            ddlVendor: [null, Validators.required]
        });
        this.vendorAWBForm = this._fb.group({
            ddlVendor: [null, Validators.required]
        })
        this.chargesForm = this._fb.group({
            ddlChargeType: [null, Validators.required],
            ddlChargeCategory: [null, Validators.required],
            ddlSurchargeType: [null, Validators.required],
            ddlChargeBand: [null, Validators.required],
            ddlCustomer: [null, Validators.required],
            ddlVendor: [null, Validators.required],
            txtFromDate: [null, Validators.required],
            txtToDate: [null, Validators.required],
            fileControl: [null, Validators.required],
        })
        this.onChangeChargeType();
        this.checkPermission();
        this.getAllVendors();
        this.getAllChargeTypes();
        this.getAllChargeBands();
        this.getAllCustomers();
    }

    ngAfterViewInit(): void {
        this.useEnterKey ? this.utilities.focusFirstElement(this.awbForm) : null;
    }

    checkPermission(): any {
        this.userData = this.appCoreService.GetUserData();
        this.useEnterKey = !this.userData.metaInfo.tabbasedtemplate;
        const permission = this.userData.config.filter(x => x.categoryname === 'Data Import');
        // console.log("permission", this.userData.config);
        if (permission.length) {
            this.permConfig.isViewAllowed = permission[0].view;
            this.permConfig.isAddAllowed = permission[0].add;
            this.permConfig.isEditAllowed = permission[0].edit;
            this.permConfig.isDeleteAllowed = permission[0].delete;
        }
    }

    getAllCustomers() {
        try {
            this.customerService.GetAll({ scid: this.appCoreService.GetUserData().selectedServiceCenter, isactive: true }).subscribe((res) => {
                if (res && res.success) {
                    this.customerList = res.data;
                }
            })
        } catch (error) {
        }
    }

    async getAllVendors() {
        const res = await lastValueFrom(this.vendorService.GetAll({ isactive: true }));
        res?.success ? this.vendorList = res.data : [];
    }

    getAllChargeTypes() {
        this.chargeService.GetAllTypes().subscribe(res => {
            try {
                if (res && res.success) {
                    this.chargeTypeList = res.data.types;
                    this.chargeCategoriesList = res.data.categories;
                }
            } catch (error) {
                console.error(error);
            }
        })
    }

    getAllChargeBands() {
        try {
            this.chargeBandsService.GetAll().subscribe((res) => {
                if (res && res.success) {
                    this.chargeBandList = res.data;
                }
            })
        } catch (error) {
            console.error(error);
        }
    }

    onTabChange(event: any) {
        this.awbForm.reset();
        this.odaForm.reset();
        this.selectedFile = null;

        if ((document.getElementById('importoda') as HTMLInputElement))
            (document.getElementById('importoda') as HTMLInputElement).value = '';

        if ((document.getElementById('importawbfile') as HTMLInputElement))
            (document.getElementById('importawbfile') as HTMLInputElement).value = '';

        if ((document.getElementById('importvendorawb') as HTMLInputElement))
            (document.getElementById('importvendorawb') as HTMLInputElement).value = '';

        if ((document.getElementById('importcharges') as HTMLInputElement))
            (document.getElementById('importcharges') as HTMLInputElement).value = '';

        if ((document.getElementById('importpincode') as HTMLInputElement))
            (document.getElementById('importpincode') as HTMLInputElement).value = '';

        this.vendorAWBForm.reset();
    }

    onChangeType() {
        if (this.chargesForm.controls.ddlChargeType.value === 1) {
            // Tariff
            this.showCategory = false;
            this.isCategoryMand = false;
            this.showDownloadBtn = true;
            this.showBands = false;
            this.showCustomer = false;
            this.showVendor = false;
            this.chargesForm.controls.ddlChargeBand.clearValidators();
            this.chargesForm.controls.ddlVendor.clearValidators();
            this.chargesForm.controls.ddlCustomer.clearValidators();
            this.chargesForm.controls.ddlChargeCategory.clearValidators();
            this.chargesForm.controls.ddlChargeCategory.reset();
            this.chargesForm.controls.ddlChargeCategory.disable();
            this.chargesForm.controls.ddlChargeBand.reset();
            this.chargesForm.controls.ddlCustomer.reset();
            this.chargesForm.controls.ddlVendor.reset();
            this.isFormSubmitted = false;
        } else if (this.chargesForm.controls.ddlChargeType.value === 2) {
            // Charge bands
            this.showCategory = false;
            this.isCategoryMand = false;
            this.showDownloadBtn = true;
            this.showBands = true;
            this.showVendor = false;
            this.chargesForm.controls.ddlChargeCategory.clearValidators();
            this.chargesForm.controls.ddlChargeBand.setValidators([Validators.required]);
            this.chargesForm.controls.ddlVendor.clearValidators();
            this.chargesForm.controls.ddlCustomer.clearValidators();
            this.chargesForm.controls.ddlChargeCategory.reset();
            this.chargesForm.controls.ddlChargeCategory.disable();

            this.isFormSubmitted = false;
        } else if (this.chargesForm.controls.ddlChargeType.value === 3) {
            // Contract
            this.showCategory = true;
            this.isCategoryMand = true;
            this.showDownloadBtn = true;
            this.showCustomer = false;
            this.showVendor = false;
            this.chargesForm.controls.ddlChargeCategory.enable();
            this.chargesForm.controls.ddlChargeCategory.setValidators([Validators.required]);
            this.chargesForm.controls.ddlCustomer.setValidators([Validators.required]);
            this.chargesForm.controls.ddlChargeBand.clearValidators();
            this.chargesForm.controls.ddlVendor.clearValidators();
            this.chargesForm.controls.ddlChargeBand.reset();
            this.chargesForm.controls.ddlVendor.reset();
            this.isFormSubmitted = false;
        } else {
            this.showDownloadBtn = false;
            this.showBands = false;
            this.showCustomer = false;
            this.showVendor = false;
        }
        this.chargesForm.controls.ddlChargeCategory.updateValueAndValidity();
        this.chargesForm.controls.ddlCustomer.updateValueAndValidity();
        this.chargesForm.controls.ddlVendor.updateValueAndValidity();
        this.chargesForm.controls.ddlChargeBand.updateValueAndValidity();
    }

    onChangeChargeType() {
        this.isFormSubmitted = false;
        this.odaForm.get('ddlCustomer').reset();
        this.odaForm.get('ddlVendor').reset();
        this.chargeType = this.odaForm.get('ddlType').value;
        const vendor = this.odaForm.get('ddlVendor').value;
        vendor ? this.odaForm.get('ddlCustomer').disable() : this.odaForm.get('ddlCustomer').enable();
        if (this.chargeType == 'Vendor') {
            this.odaForm.get('ddlCustomer').setValue(null);
            this.odaForm.get('ddlCustomer').disable();
            this.odaForm.get('ddlCustomer').clearValidators();
            this.odaForm.get('ddlVendor').setValidators([Validators.required]);
            this.CustomerType = false;
        } else if (this.chargeType == 'Tariff') {
            this.odaForm.get('ddlCustomer').setValue(null);
            this.odaForm.get('ddlCustomer').disable();
            this.odaForm.get('ddlCustomer').clearValidators();
            this.odaForm.get('ddlVendor').clearValidators();
            this.CustomerType = false;
        }
        else {
            this.odaForm.get('ddlCustomer').enable();
            this.odaForm.get('ddlVendor').clearValidators();
            this.odaForm.get('ddlCustomer').setValidators([Validators.required]);
            this.CustomerType = true;
        }
        this.odaForm.get('ddlCustomer').updateValueAndValidity();
        this.odaForm.get('ddlVendor').updateValueAndValidity();
    }

    onChangeChargeCategory() {
        const selectedCategory = this.chargesForm.get('ddlChargeCategory').value;
        this.showBands = false;
        if (selectedCategory === 1) {
            // Customer
            this.showCustomer = true;
            this.showVendor = false;
            this.chargesForm.get('ddlVendor').reset();
            this.chargesForm.get('ddlVendor').clearValidators();
            this.chargesForm.get('ddlCustomer').setValidators([Validators.required]);
        } else if (selectedCategory === 2) {
            // Vendor
            this.showCustomer = false;
            this.showVendor = true;
            this.chargesForm.get('ddlCustomer').reset();
            this.chargesForm.get('ddlCustomer').clearValidators();
            this.chargesForm.get('ddlVendor').setValidators([Validators.required]);
        } else {
            this.showCustomer = false;
            this.showVendor = false;
            this.chargesForm.get('ddlVendor').clearValidators();
            this.chargesForm.get('ddlCustomer').clearValidators();
        }
        this.chargesForm.get('ddlCustomer').updateValueAndValidity();
        this.chargesForm.get('ddlVendor').updateValueAndValidity();
    }

    downloadFormatFile(filePath: string) {
        try {
            const fileDomainURL = this.utilities.getS3DownloadURL();
            let fileName = '';
            let downloadFileURL = '';

            if (filePath) {
                fileName = filePath.substring(filePath.lastIndexOf('/') + 1);
            }

            downloadFileURL = `${fileDomainURL}${filePath}`;
            saveAs(downloadFileURL, fileName);
        } catch (e) {
            console.log(e);
        }
    }

    onChangeFileSelect(evt) {
        this.selectedFile = evt.target.files[0];
    }

    uploadAWBFile(tabName?: string) {
        try {
            this.isFormSubmitted = true;
            if (!this.selectedFile) {
                this.appCoreService.showMessage('Select an excel file to upload', '', 'error');
                return;
            }
            if (tabName === 'vendorAWB' ? this.vendorAWBForm.invalid : this.awbForm.invalid) {
                this.appCoreService.showMessage('Invalid form.', '', 'error');
                return;
            }
            let requestObj = {
                name: this.selectedFile.name,
                fileType: this.selectedFile.type,
                category: 'awb-import'
            };
            this.ngxLoaderService.start();
            this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe((res) => {
                if (res && res.success) {
                    // console.log("RESDATA-GetSignedURLForUpload",res.data)
                    const signedUrl = res.data.uploadURL;
                    const fileId = res.data.fileId;
                    if (signedUrl) {
                        // console.log("SIGNEDURL")
                        let headers: HttpHeaders = new HttpHeaders({
                            "Content-Type": requestObj.fileType
                        });

                        this.fileHandlerService.UploadFile(signedUrl, this.selectedFile, headers).subscribe((f) => {
                            if (f === null) {
                                // console.log("res-UploadFile",res.data);
                                const reqObj = {
                                    signedUrl: res.data.uploadURL,
                                    fileId: res.data.fileId,
                                    filePath: res.data.filePath,
                                    domainURL: res.data.domainURL,
                                    selectedSCId: this.userData?.metaInfo?.servicecenters?.find((item) => item.isdefault = true)?.id,
                                    isactive: true,
                                    jobType: 'IMPORT',
                                    jobCategory: this.awbForm.get('ddlType')?.value,
                                    vendorid: ''
                                }
                                if (tabName === 'vendorAWB') {
                                    reqObj.jobCategory = 'vendorAWB';
                                    reqObj.vendorid = this.vendorAWBForm.get('ddlVendor').value
                                }
                                // console.log("reqobj", reqObj);
                                this.jobService.add(reqObj).subscribe(res => {
                                    if (res && res.success) {
                                        this.ngxLoaderService.stop();
                                        // console.log("RREESDATA", res);
                                        if (res?.data?.err_msg) {
                                            this.appCoreService.showMessage(res?.data?.err_msg, '', 'error');
                                            return;
                                        } else {
                                            this.appCoreService.showMessage('Job added to the queue', '', 'success');
                                            this.jobAdded = true;
                                            // this.bindJobList(true);
                                            this.selectedFile = null;

                                            if ((document.getElementById('importawbfile') as HTMLInputElement))
                                                (document.getElementById('importawbfile') as HTMLInputElement).value = '';

                                            if ((document.getElementById('importvendorawb') as HTMLInputElement))
                                                (document.getElementById('importvendorawb') as HTMLInputElement).value = '';

                                            this.isFormSubmitted = false;
                                        }
                                    } else if (res && !res.success) {
                                        this.ngxLoaderService.stop();
                                        this.appCoreService.showMessage(res?.data?.err_msg, '', 'error');
                                    }
                                })
                            }
                        });
                    }
                }
            })
        } catch (err) {
            this.ngxLoaderService.stop();
            console.error(err);
        }
    }


    uploadODAFile() {
        try {
            this.isFormSubmitted = true;
            if (!this.selectedFile) {
                this.appCoreService.showMessage('Select an excel file to upload', '', 'error');
                return;
            }
            if (this.odaForm.invalid) {
                this.appCoreService.showMessage('Invalid form.', '', 'error');
                return;
            }

            this.ngxLoaderService.start();
            let requestObj = {
                name: this.selectedFile.name,
                fileType: this.selectedFile.type,
                category: 'oda-import'
            };
            this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe((res) => {
                if (res && res.success) {
                    const signedUrl = res.data.uploadURL;
                    const fileId = res.data.fileId;
                    if (signedUrl) {
                        let headers: HttpHeaders = new HttpHeaders({
                            "Content-Type": requestObj.fileType
                        });

                        this.fileHandlerService.UploadFile(signedUrl, this.selectedFile, headers).subscribe((f) => {
                            if (f === null) {
                                const reqObj = {
                                    signedUrl: res.data.uploadURL,
                                    fileId: res.data.fileId,
                                    filePath: res.data.filePath,
                                    domainURL: res.data.domainURL,
                                    isactive: true,
                                    jobType: 'IMPORT',
                                    jobCategory: 'ODA',
                                    importType: this.odaForm.get('ddlType')?.value,
                                    vendorid: this.odaForm.get('ddlVendor')?.value,
                                    customerid: this.odaForm.get('ddlCustomer')?.value
                                }
                                // console.log("reqobj", reqObj);
                                this.jobService.add(reqObj).subscribe(res => {
                                    if (res && res.success) {
                                        // console.log("RREESDATA", res);
                                        this.ngxLoaderService.stop();
                                        if (res?.data?.err_msg) {
                                            this.appCoreService.showMessage(res?.data?.err_msg, '', 'error');
                                            return;
                                        }
                                        this.appCoreService.showMessage('Job added to the queue', '', 'success');
                                        this.jobAdded = true;

                                        this.odaForm.reset();
                                        this.selectedFile = null;
                                        (document.getElementById('importoda') as HTMLInputElement).value = '';
                                        this.isFormSubmitted = false;
                                    }
                                })
                            }
                        });
                    }
                }
            })
        } catch (err) {
            this.ngxLoaderService.stop();
            console.error(err);
        }
    }

    downloadChargeFormatFile() {
        this.ngxLoaderService.start();
        try {
            const fileDomainURL = this.utilities.getS3DownloadURL();
            let fileName = '';
            let downloadFileURL = '';
            const selectedChargeType = this.chargesForm.get('ddlChargeType').value;
            const selectedChargeCategory = this.chargesForm.get('ddlChargeCategory').value;
            const selectedSurgeCategory = this.chargesForm.get('ddlSurchargeType').value;
            if (selectedChargeType) {
                let filePath = '';
                if (selectedChargeType === 1) {
                    if (selectedSurgeCategory === 'Fuel Surcharge') {
                        filePath = this.chargeTypeList.filter(x => x.id === selectedChargeType)[0]?.fuelfilepath;
                    } else {
                        filePath = this.chargeTypeList.filter(x => x.id === selectedChargeType)[0]?.chargesfilepath;
                    }
                } else if (selectedChargeType === 2) {
                    if (selectedSurgeCategory === 'Fuel Surcharge') {
                        filePath = this.chargeTypeList.filter(x => x.id === selectedChargeType)[0]?.fuelfilepath;
                    } else {
                        filePath = this.chargeTypeList.filter(x => x.id === selectedChargeType)[0]?.chargesfilepath;
                    }

                } else if (selectedChargeType === 3) {
                    // contract
                    if (selectedSurgeCategory === 'Fuel Surcharge') {
                        filePath = this.chargeCategoriesList.filter(x => x.id === selectedChargeCategory)[0]?.fuelfilepath;
                    } else {
                        filePath = this.chargeCategoriesList.filter(x => x.id === selectedChargeCategory)[0]?.chargesfilepath;
                    }
                }

                if (filePath) {
                    // console.log('filePath',filePath)
                    fileName = filePath.substring(filePath.lastIndexOf('/') + 1);
                }
                downloadFileURL = `${fileDomainURL}${filePath}`;
            }
            saveAs(downloadFileURL, fileName);
            this.ngxLoaderService.stop();
        } catch (e) {
            this.ngxLoaderService.stop();
        }
    }

    uploadCharges() {
        this.isFormSubmitted = true;
        try {
            if (this.chargesForm.valid) {
                // upload file to server
                if (this.selectedFile) {
                    const chargeTypeId = this.chargesForm.get('ddlChargeType').value;
                    const chargeCategoryId = this.chargesForm.get('ddlChargeCategory').value;
                    let selectedUploadTypeText = this.chargeTypeList.filter(x => x.id === chargeTypeId)[0].ratetype;
                    let isChargePeriodValid = false;
                    let chargeRequestObj = {
                        fromdate: this.chargesForm.get('txtFromDate').value,
                        todate: this.chargesForm.get('txtToDate').value,
                        chargetypeid: chargeTypeId,
                        chargecategoryid: chargeCategoryId,
                        surchargetype: this.chargesForm.get('ddlSurchargeType').value,
                        rateband: this.chargesForm.get('ddlChargeBand')?.value,
                        customer: this.chargesForm.get('ddlCustomer')?.value,
                        vendor: this.chargesForm.get('ddlVendor')?.value
                    };

                    this.ngxLoaderService.start();
                    this.chargeService.CheckChargePeriod(chargeRequestObj).subscribe(res => {
                        try {
                            if (res && res.success) {
                                // console.log(res);
                                isChargePeriodValid = res.data?.id;
                                if (!isChargePeriodValid) {
                                    let requestObj = {
                                        name: this.selectedFile.name,
                                        fileType: this.selectedFile.type,
                                        category: selectedUploadTypeText
                                    };
                                    // get signed url and upload file
                                    this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe(res => {
                                        try {
                                            if (res && res.success) {
                                                const signedUrl = res.data.uploadURL;
                                                const fileId = res.data.fileId;
                                                if (signedUrl) {
                                                    let headers: HttpHeaders = new HttpHeaders({
                                                        "Content-Type": requestObj.fileType
                                                    });
                                                    this.fileHandlerService.UploadFile(signedUrl, this.selectedFile, headers).subscribe((f) => {
                                                        if (f === null) {

                                                            const reqObj = {
                                                                signedUrl: res.data.uploadURL,
                                                                fileId: res.data.fileId,
                                                                filePath: res.data.filePath,
                                                                domainURL: res.data.domainURL,
                                                                isactive: true,
                                                                jobType: 'IMPORT',
                                                                jobCategory: 'CHARGES',
                                                                chargetypeid: this.chargesForm.controls.ddlChargeType.value,
                                                                chargecategory: this.chargesForm.controls.ddlChargeCategory.value,
                                                                surchargetype: this.chargesForm.controls.ddlSurchargeType.value,
                                                                fromdate: this.chargesForm.controls.txtFromDate.value,
                                                                todate: this.chargesForm.controls.txtToDate.value,
                                                                band: this.chargesForm.controls.ddlChargeBand.value,
                                                                customerid: this.chargesForm.controls.ddlCustomer.value,
                                                                vendorid: this.chargesForm.controls.ddlVendor.value
                                                            }
                                                            // console.log("reqobj", reqObj);
                                                            this.jobService.add(reqObj).subscribe(res => {
                                                                if (res && res.success) {
                                                                    // console.log("RREESDATA", res);
                                                                    this.ngxLoaderService.stop();
                                                                    if (res?.data?.err_msg) {
                                                                        this.appCoreService.showMessage(res?.data?.err_msg, '', 'error');
                                                                        return;
                                                                    }
                                                                    this.appCoreService.showMessage('Job added to the queue', '', 'success');
                                                                    this.jobAdded = true;
                                                                    // this.bindJobList(true);
                                                                    this.isFormSubmitted = false;
                                                                    this.chargesForm.reset();
                                                                    (document.getElementById('importcharges') as HTMLInputElement).value = '';
                                                                }
                                                            })
                                                        }
                                                    });
                                                } else {
                                                    this.ngxLoaderService.stop();
                                                }
                                            } else if (res && !res.success) {
                                                this.ngxLoaderService.stop();
                                            }
                                        } catch (error) {
                                            this.ngxLoaderService.stop();
                                            console.error(error);
                                        }
                                    });
                                } else {
                                    this.ngxLoaderService.stop();
                                    this.isFormSubmitted = false;
                                    let msg = `An active charge period for type - <b>${selectedUploadTypeText}</b>
                                                is already available. Please update the date range and try uploading again.`;
                                    this.invalidPeriodDialog(msg);
                                }
                            }
                        } catch (error) {
                            console.error(error);
                            this.ngxLoaderService.stop();
                        }
                    });
                } else {
                    console.log('No file selected');
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    async invalidPeriodDialog(msg: string) {
        const result = await Swal.fire({
            titleText: 'Error',
            html: msg,
            icon: 'error',
            // confirmButtonText: 'Yes',
            // showDenyButton: true,
            // denyButtonText: 'No',
            allowEscapeKey: false,
            allowOutsideClick: false
        });

        if (result.isConfirmed) {
            return false;
        }
    }

    uploadPincodeFile() {
        try {
            this.isFormSubmitted = true;
            if (!this.selectedFile) {
                this.appCoreService.showMessage('Select an excel file to upload', '', 'error');
                return;
            }

            let requestObj = {
                name: this.selectedFile.name,
                fileType: this.selectedFile.type,
                category: 'pincodes-import'
            };
            this.ngxLoaderService.start();
            this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe((res) => {
                if (res && res.success) {
                    // console.log("RESDATA-GetSignedURLForUpload",res.data)
                    const signedUrl = res.data.uploadURL;
                    const fileId = res.data.fileId;
                    if (signedUrl) {
                        // console.log("SIGNEDURL")
                        let headers: HttpHeaders = new HttpHeaders({
                            "Content-Type": requestObj.fileType
                        });

                        this.fileHandlerService.UploadFile(signedUrl, this.selectedFile, headers).subscribe((f) => {
                            if (f === null) {
                                // console.log("res-UploadFile",res.data);
                                const reqObj = {
                                    signedUrl: res.data.uploadURL,
                                    fileId: res.data.fileId,
                                    filePath: res.data.filePath,
                                    domainURL: res.data.domainURL,
                                    selectedSCId: this.userData?.metaInfo?.servicecenters?.find((item) => item.isdefault = true)?.id,
                                    isactive: true,
                                    jobType: 'IMPORT',
                                    jobCategory: 'pincodes',
                                }
                                // console.log("reqobj", reqObj);
                                this.jobService.add(reqObj).subscribe(res => {
                                    if (res && res.success) {
                                        this.ngxLoaderService.stop();
                                        // console.log("RREESDATA", res);
                                        if (res?.data?.err_msg) {
                                            this.appCoreService.showMessage(res?.data?.err_msg, '', 'error');
                                            return;
                                        } else {
                                            this.appCoreService.showMessage('Job added to the queue', '', 'success');
                                            this.jobAdded = true;
                                            this.selectedFile = null;

                                            if ((document.getElementById('importpincode') as HTMLInputElement))
                                                (document.getElementById('importpincode') as HTMLInputElement).value = '';

                                            this.isFormSubmitted = false;
                                        }
                                    } else if (res && !res.success) {
                                        this.ngxLoaderService.stop();
                                        this.appCoreService.showMessage(res?.data?.err_msg, '', 'error');
                                    }
                                })
                            }
                        });
                    }
                }
            })
        } catch (err) {
            this.ngxLoaderService.stop();
            console.error(err);
        }
    }

}